module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/stuff-in-unit.webp";